import { CustomerProfile } from '@/models';
import { AccountPageLoadEvent } from '@/services/analytics/events';
import { GuacModeLinkClickEvent } from '@/services/analytics/events/guac-mode-link-click';
import { GuacModeLinkClickType, LinkClickElementType, PageLoadEventType } from '@/services/analytics/platforms/adobe-analytics/models';
import { EnrollmentOptions } from '@/services/loyalty/loyalty.service';
import { MUTATIONS as CUSTOMER_MUTATIONS } from '@/store/customer';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'CmgGuacModeJoinRewardsModal',
})
export default class CmgGuacModeJoinRewardsModal extends Vue {
  get visible(): boolean {
    return this.$appStore.state.ui.modals.guacModeJoinRewards.visible;
  }

  get legalCopy(): string {
    return this.$services.config.getLegalText().loggedInUnEnrolled;
  }

  get guacModePepperImageUrl(): string {
    return this.$appStore.state.cms.images.icons.guacModePepperBadge.default;
  }

  get profile() {
    return this.$appStore.state.customer.profile;
  }

  get customer(): CustomerProfile | null {
    return this.profile && !this.profile.isGuest ? this.profile : null;
  }

  get isEnrolledInLoyalty() {
    return this.$services.loyalty.isEnrolledInLoyalty(this.customer);
  }

  @Watch('visible', { immediate: true })
  async visibleChanged(visible: boolean) {
    if (visible) {
      Vue.nextTick(() => {
        setTimeout(() => (this.$refs.mainTitle as HTMLElement).focus(), 500);
      });
    }
  }

  async onClickJoinNow() {
    this.$services.ui.setModalVisibility('guacModeJoinRewards', false);
    this.$services.analytics.send(new GuacModeLinkClickEvent(GuacModeLinkClickType.JoinNow, LinkClickElementType.Button));
    const enrollmentOptions: EnrollmentOptions = { customer: this.customer, pageTitle: document.title };
    await this.$services.loyalty.enrollInLoyalty(enrollmentOptions);
    this.enrollInGuacMode();
    this.$services.ui.showOnboardingModal(this.$services.customer, this.customer ?? undefined);
  }

  onClickVerifyMe() {
    this.enrollInGuacMode();
    this.$services.analytics.send(new GuacModeLinkClickEvent(GuacModeLinkClickType.VerifyMe, LinkClickElementType.Button, this.isEnrolledInLoyalty));
    this.$services.ui.setModalVisibility('guacModeJoinRewards', false);
    this.$services.ui.setModalVisibility('guacModeVerified', true);
    this.$services.analytics.send(new AccountPageLoadEvent(PageLoadEventType.GuacModeVerified));
  }

  onClickHowGuacModeWorks(): void {
    this.$services.analytics.send(new GuacModeLinkClickEvent(GuacModeLinkClickType.HowGuacModeWorks, LinkClickElementType.Button, this.isEnrolledInLoyalty));
    window.open('/guacmode', '_blank');
  }

  get userIsGuacMode(): boolean {
    return this.$appStore.getters.isCustomerGuacMode
  }

  enrollInGuacMode() {
    this.$services.customer.updateCustomer({ isGuacMode: true });
    const profile = this.customer;
    profile!.isGuacMode = true;
    this.$store.commit(CUSTOMER_MUTATIONS.SET_CUSTOMER_PROFILE, profile);
  }

  close() {
    this.$services.ui.setModalVisibility('guacModeJoinRewards', false);
    Vue.nextTick(() => {
      setTimeout(() => {
        this.$services.ui.focusBack();
      }, 1000);
    });
  }
}
